import { Outlet } from "react-router";
import { OrganizationRouteGuard } from "@/features/auth/components/OrganizationRouteGuard";
import { PlanRouteGuard } from "@/features/auth/components/PlanRouteGuard";
import { SponsorshipLayout } from "@/features/sponsorship/components/layout/SponsorshipLayout";

// Les deux guards de l'ancienne page sont conservés (delta vs predictions
// qui n'a pas OrganizationRouteGuard).
export const SponsorshipLayoutOutlet = () => (
  <PlanRouteGuard requiredFeature="service_sponsorship">
    <OrganizationRouteGuard hiddenFeature="service_sponsorship">
      <SponsorshipLayout>
        <Outlet />
      </SponsorshipLayout>
    </OrganizationRouteGuard>
  </PlanRouteGuard>
);

SponsorshipLayoutOutlet.displayName = "SponsorshipLayoutOutlet";
